var map = {
	"./adult/se/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 738,
	"./youth/se/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 737;